import axoisHttpUtil from "./axiosUtil";

export const apiReducer = (state, action, module) => {
  const { actionKey, errorActionKey, module: actionModule } = action;
  if (!actionKey || !actionModule || actionModule !== module) {
    return state;
  }

  const actionSuffix =
    action.type.split("_")[action.type.split("_").length - 1];
  switch (actionSuffix) {
    case "START":
      return {
        ...state,
        [`${actionKey}Start`]: true,
        [errorActionKey ? errorActionKey : `${actionKey}Error`]: null,
        [actionKey]: null,
      };
    case "SUCCESS":
      return {
        ...state,
        [`${actionKey}Start`]: false,
        [errorActionKey ? errorActionKey : `${actionKey}Error`]: null,
        [actionKey]: action.data,
      };
    case "ERROR":
      return {
        ...state,
        [`${actionKey}Start`]: false,
        [errorActionKey ? errorActionKey : `${actionKey}Error`]: action.data,
      };
    default:
      return state;
  }
};

export const apiPostDispatch = async (dispatch, params) => {
  const {
    type,
    requestDispatchEnable = true,
    errorDispatchEnable = true,
    successDispatchEnable = true,
    endPoint,
    data,
    config,
    method,
    headers,
    ...rest
  } = params;

  if (requestDispatchEnable) {
    dispatch({
      type: `${type}_START`,
      ...rest,
    });
  }

  let res = {};
  if (!method) {
    res = await axoisHttpUtil.post(endPoint, data, { config, headers });
  } else if (method === "PUT") {
    res = await axoisHttpUtil.put(endPoint, data, { config });
  } else if (method === "DELETE") {
    res = await axoisHttpUtil.delete(endPoint, { data }, { config });
  } else if (method === "GET") {
    res = await axoisHttpUtil.get(endPoint, { data }, { config });
  }

  if (res && res.data) {
    if (res.data.status === "SUCCESS") {
      if (successDispatchEnable) {
        dispatch({
          type: `${type}_SUCCESS`,
          data: res.data.data,
          ...rest,
        });
      }
    } else {
      if (errorDispatchEnable) {
        dispatch({
          type: `${type}_ERROR`,
          data: res.data.error,
          ...rest,
        });
      }
    }
  }
  return res;
};

export default {
  apiReducer,
  apiPostDispatch,
};
